module.exports = {"errorRequired":"This field is required.","errorInvalid":"The format is invalid.","urlAlreadyExist":"This URL already exists. Please use another one."}


//////////////////
// WEBPACK FOOTER
// ./src/components/OnboardComplete/locales/fr.json
// module id = 1964
// module chunks = 0